<template>
  <div class="result">
    <!--顶部导航-->
    <Navbar title="资质认证" :isSpecialBack="true" @goBack="handleBack" />
    <!--结果页面-->
    <div class="result-content">
      <!--结果图标-->
      <div class="result-icon">
        <img src="@/assets/style/certification-icon.png" alt="" />
      </div>
      <div class="result-title">资质审核中，请耐心等待</div>
      <div class="result-btn">
        <div class="btn" @click="handleViewOtherClick">查看其他推荐产品</div>
        <div class="btn" @click="handleBackClick">返回首页</div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";

export default {
  name: "Settings",
  components: {
    Navbar,
  },
  data() {
    return {
      isNavigatingAway: false,
    };
  },
  async mounted() {
  },
  methods: {
    handleBack() {
      this.$router.push({ name: "Home" });
    },
    handleBackClick() {
      this.$router.push({ name: "Home" });
    },
    handleViewOtherClick() {
      if(this.admissionAd.urlType == 2) return;
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", {
          type: "10",
          url: this.admissionAd.url,
          title: this.admissionAd.name,
        });
      } else {
        window.location.href = this.admissionAd.url;
      }
    },
  },
  /**
   * 3. Vue Router 守卫双保险（兼容 History 模式）
   */
  beforeRouteLeave(to, from, next) {
    // 如果安全锁已经打开，说明是我们自己触发的 executeCustomNavigation，直接无条件放行
    if (this.isNavigatingAway) {
      next();
      return;
    }

    // 否则，说明用户通过其他方式离开（或 History 模式物理返回触发）
    next(false); // 卡死默认行为
    this.executeCustomNavigation(); // 走安全跳转流程
  },
  computed: {
    admissionAd() {
      return this.$store.state.admissionAd;
    },
  },
};
</script>

<style scoped lang="scss">
.result {
  position: relative;
}
.result-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 175px;
  .result-icon {
    img {
      width: 110px;
      height: 110px;
    }
  }
  .result-title {
    font-size: 14px;
    color: #333;
    margin-top: 10px;
  }
  .result-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 35px;
  }
  .btn {
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 25px;
    font-size: 15px;
    margin-bottom: 20px;
  }
  .btn:nth-child(1) {
    background-color: #007aff;
    color: #fff;
  }
  .btn:nth-child(2) {
    background: #f1f1f1;
    color: rgba(51, 51, 51, 0.4);
  }
}
</style>
